import PayersPage from './PayersPage'

export default PayersPage
